import { createElement } from 'react';
import { Box } from '@mui/material';
import ExtendTimeCorrection from './extended-request-versions/ExtendTimeCorrection';
import ExtendTimeCompensation from './extended-request-versions/ExtendTimeCompensation';
import { ExtendVacation } from './extended-request-versions/ExtendVacation';
import { ExtendSick } from './extended-request-versions/ExtendSick';
import { ExtendTravelExpense } from './extended-request-versions/ExtendTravelExpense';
import RequestEditHistory from '../../components/special/RequestEditHistory';

const ExtendRequest = ({ request, onUpdate }) => {
  return (
    <Box className="flex flex-col gap-2 w-full">
      {createElement(activeTypes[request.type], {
        request,
        onUpdate: onUpdate,
      })}
      <RequestEditHistory request={request} />
    </Box>
  );
};

const activeTypes = {
  timeCorrection: ExtendTimeCorrection,
  timeCompensation: ExtendTimeCompensation,
  vacation: ExtendVacation,
  sick: ExtendSick,
  travelExpense: ExtendTravelExpense,
};

export default ExtendRequest;
